'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
require('backbone.stickit');
const AppRouter = require('balus/app/router/index');
const Route = require('common/route');
const IdeaUpdateService = require('feedback/app/service/idea/update');
const States = require('feedback/domain/value/idea-state');
const SidebarView = require('common/ui/view/sidebar/index');
const SidebarCollection = require('common/ui/view/sidebar/collection');
const AdminCoverView = require('feedback/ui/view/admin/common/cover');
const CommentView = require('feedback/ui/view/idea/comment');
const UserRequestDetailViewTemplate = require('feedback/ui/template/admin/idea/edit.hbs');
const StateRadioTemplate = require('feedback/ui/template/admin/idea/state-radio.hbs');
const EstimateRadioTemplate = require('feedback/ui/template/admin/idea/estimate-radio.hbs');
const PublicRadioTemplate = require('feedback/ui/template/admin/idea/public-radio.hbs');
const Marked = require('balus/util/marked');
const Tooltip = require('common/ui/view/behavior/tooltip');
const Dialog = require('common/util/dialog');

const StateEditView = Mn.View.extend({
    tagName: 'span',
    template: StateRadioTemplate,
    behaviors: {
        Tooltip: {
            behaviorClass: Tooltip,
        }
    },

    templateContext: function() {
        const state = this.model.get('state');
        const isCurrentState = (state.name == this.getOption('idea').getState().name);
        return {
            name: state.name,
            color: state.color,
            isCurrentState: isCurrentState
        };
    }
});

const StateEditListView = Mn.CollectionView.extend({
    childView: StateEditView,
    childViewOptions: function() {
        return {
            idea: this.getOption('idea')
        };
    },
    childViewTriggers: {
        'select': 'select:state'
    }
});

const EstimateEditView = Mn.View.extend({
    tagName: 'span',
    template: EstimateRadioTemplate,

    templateContext: function() {
        const estimate = this.model.get('estimate');
        const isCurrentEstimate = (estimate == this.getOption('idea').getEstimate());
        return {
            isCurrentEstimate: isCurrentEstimate
        };
    }
});

const EstimateEditListView = Mn.CollectionView.extend({
    childView: EstimateEditView,
    childViewOptions: function () {
        return {
            idea: this.getOption('idea')
        };
    },
    childViewTriggers: {
        'select': 'select:estimate'
    }
});

const PublicEditView = Mn.View.extend({
    tagName: 'span',
    template: PublicRadioTemplate,
    events: {
        'change .public': 'onChange'
    },

    templateContext: function() {
        return {
            isPublic: this.getOption('idea').isPublic()
        }
    },

    onChange: function() {
        const isPublic = _.isEqual(this.$('.public:checked').val(), 'public');
        this.getOption('idea').set('public', isPublic);
    }
});

/**
 * ユーザからの要望を詳しく表示する View
 * (要望詳細、コメント一覧、コメント投稿フォームを内包する)
 */
module.exports = Mn.View.extend({
    tagName: 'div',
    className: 'row',
    template: UserRequestDetailViewTemplate,
    ui: {
        relatedURLs: '.related-urls textarea',
        summary: '.summary textarea'
    },
    events: {
        'click .save': 'save'
    },
    regions: {
        public: '.public',
        ideaStates: '.states',
        estimates: '.estimates',
        sidebar: '#sidebar',
        cover: '#cover',
    },
    childViewEvents: {
        'select:state': 'selectState',
        'select:estimate': 'selectEstimate'
    },
    bindings: {
        'input.assignees': 'assignees',
        'input.estimate': 'estimate',
        'input.state': 'state'
    },

    templateContext: function() {
        return {
            isPublic: this.model.isPublic(),
            body: Marked()(this.model.getBody()),
            commentNum: this.model.comments.length,
            relatedURLs: this.model.getRelatedURLs().join('\n')
        };
    },

    initialize: function() {
        // 他のViewとも共有されている編集対象の Idea Model を this.originalModel に保持する。
        // this.model は、編集中のフォームの状態と連動するように、 this.originalModel を複製したものをセットする。
        // 編集結果を保存したときに this.model は破棄され、 this.originalModel の属性が変更される。
        this.originalModel = this.model;
        this.listenTo(this.originalModel.comments, 'add', this.render);

        this.model = this.originalModel.clone();
    },

    onDomRefresh: function() {
        this.showChildView('cover', new AdminCoverView({isIdea: true}));

        this.showChildView('ideaStates', new StateEditListView({
            collection: new Backbone.Collection(_.map(States, s => {
                return {state: s};
            })),
            idea: this.model
        }));

        const estimateChoices = this.model.getEstimateChoices();
        this.showChildView('estimates', new EstimateEditListView({
            collection: new Backbone.Collection(_.map(estimateChoices, e => {
                return {estimate: e};
            })),
            idea: this.model
        }));

        this.showChildView('public', new PublicEditView({
            idea: this.model
        }));

        const navs = new SidebarCollection(
            [
                {
                    name: 'comment',
                    icon: 'fa fa-comments-o',
                    label: 'module/word:comment',
                    view: new CommentView({
                        // コメントを追加する対象は、編集中の Idea Model (複製) ではなく、
                        // 他のViewやCollectionと共有されている this.originalModel を参照する
                        model: this.originalModel,
                        collection: this.originalModel.comments
                    }),
                    open: true
                },
            ]
        );

        this.showChildView('sidebar', new SidebarView({
            navs: navs,
            horizontalNav: true
        }));

        this.stickit();

        $.material.init();
    },

    _save: function() {
        (new IdeaUpdateService(
            this.model,
            this.model.get('state'),
            this.parseList(this.ui.relatedURLs.val()),
            this.model.get('assignees'),
            this.model.get('estimate'),
            this.ui.summary.val(),
            this.model.isPublic()
        ))
            .execute()
            .then(() => {
                AppRouter.navigate(`/feedback/admin/ideas/${this.model.id}`, {trigger: true})
            });
    },

    save: function() {
        const changeToReleased =
            this.model.getState().isReleased() &&
            this.originalModel.getState().isNotReleased();
        const changeFromReleased =
            this.originalModel.getState().isReleased() &&
            this.model.getState().isNotReleased();

        if (changeToReleased) {
            Dialog.confirm({
                text: '状態を「リリース済み」に変更すると、関係者に通知が送信されます。<br>保存してよろしいですか？',
                okCallback: () => {
                    this._save();
                }
            });
        } else if (changeFromReleased) {
            Dialog.confirm({
                text: '状態を「リリース済み」に変更したときに、関係者に通知が送信済みです。' +
                    '状態変更の旨をコメント欄などでフォローしてください。保存してよろしいですか？',
                okCallback: () => {
                    this._save();
                }
            });
        } else {
            this._save();
        }
    },

    parseList: function(text) {
        let list = text.replace(/,/, ' ').split(/(\t|\s|\n)+/);
        list = _.filter(list, (val) => {
            val = val.replace(/\s/, '');
            if (val.length > 0) {
                return val;
            }
        });
        return list;
    },

    selectState: function(childView) {
        this.model.set('_state', childView.model.get('state'));
    },

    selectEstimate: function(childView) {
        this.model.set('estimate', childView.model.get('estimate'));
    }
});



// WEBPACK FOOTER //
// ./feedback/ui/view/admin/idea/edit.js